import { render, staticRenderFns } from "./zen_icf3.vue?vue&type=template&id=3cf05050&scoped=true&"
import script from "./zen_icf3.vue?vue&type=script&lang=js&"
export * from "./zen_icf3.vue?vue&type=script&lang=js&"
import style0 from "./zen_icf3.vue?vue&type=style&index=0&id=3cf05050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf05050",
  null
  
)

export default component.exports